import React, { ForwardRefExoticComponent } from 'react';
import Button, {
  ButtonProps as MuiButtonProps,
} from '@material-ui/core/Button';
import Skeleton, { SkeletonProps } from '@material-ui/lab/Skeleton';
import makeStyles from '@material-ui/core/styles/makeStyles';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  skeleton: {
    maxWidth: 'none',
    display: 'inline-flex',
    '& > *': {
      visibility: 'hidden',
    },
  },
}));

type SkeletonButtonProps = {
  loaded?: boolean | null,
  component?: React.ComponentType,
} & MuiButtonProps;

const ButtonSkeleton = React.forwardRef(
  (props: MuiButtonProps & SkeletonProps, ref) => (
    <Skeleton {...props} ref={ref} variant="rect" />
  ),
);

const SkeletonButton: ForwardRefExoticComponent<SkeletonButtonProps> =
  React.forwardRef(({ loaded, ...buttonProps }: SkeletonButtonProps, ref) => {
    const classes = useStyles();

    const isNoChildren = buttonProps.children == null;

    return (
      <Button
        {...buttonProps}
        ref={ref}
        {...(!loaded && {
          disabled: true,
          children: isNoChildren ? 'button' : buttonProps.children,
          component: ButtonSkeleton,
          className: clsx(buttonProps?.className, classes.skeleton),
          style: {
            ...buttonProps?.style,
            ...(isNoChildren && { minWidth: 100 }),
          },
        })}
      />
    );
  });

export default SkeletonButton;
